"use client";
import { useInView } from "react-intersection-observer";

export default function FooterWave() {
  const [ref, inView] = useInView({ threshold: 0.5 });

  return (
    <div
      className={`position-relative footer-branding ${
        inView ? "animated" : ""
      }`}
      ref={ref}
    >
      <img
        className="position-absolute footer-branding__item zindex-1000"
        src="/portal/img/hellgruen.svg"
        alt="publicare branding"
      />
      <img
        className="position-absolute footer-branding__item zindex-1020"
        src="/portal/img/mittelgruen.svg"
        alt="publicare branding"
      />
      <img
        className="position-absolute footer-branding__item zindex-1030"
        src="/portal/img/dunkelgruen.svg"
        alt="publicare branding"
      />
      <img
        className="position-absolute footer-branding__item zindex-1040"
        src="/portal/img/blau.svg"
        alt="publicare branding"
      />
    </div>
  );
}
